import format from "date-fns/format";

export default function formatDate(date) {
  if (!date) {
    return;
  }

  return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
}
